'use strict';

var proRegularSvgIcons = {};

exports.__exports = proRegularSvgIcons;
//# sourceMappingURL=index3.cjs.map
